import React, {useRef, useState} from 'react';
import {IBook, IKeyWord} from "../../models/Book";
import './KeyWord.css';
import {useSearchParams} from "react-router-dom";
import {GetAllSearchParams} from "../../utilities/GetAllSearchParams";

interface IKeyWordProps {
    KeyWords:IKeyWord[]
}

const KeyWord = (props:IKeyWordProps) => {

    const [isOpenKeyWords, setIsOpenKeyWords] = useState(false);
    const ref = useRef(null);

    const [searchParams,setSearchParams] = useSearchParams();

    const openCollapsed = () => {
        const elemet = ref.current as unknown as HTMLDivElement;
        if (isOpenKeyWords == true){
            elemet.style.maxHeight = '0px';
        } else {
            elemet.style.maxHeight = elemet.scrollHeight + "px";
        }
    }

    const onKeyWordClick = (KeyWord:string) => {

        const params = GetAllSearchParams(searchParams);
        // @ts-ignore
        if(!params["keyWords"])
        {
            setSearchParams({...params,keyWords:String(KeyWord)});
        }
        else {
            // @ts-ignore
            if(params["keyWords"].includes(KeyWord)){
                // @ts-ignore
                params["keyWords"] = params["keyWords"].replace('|'+KeyWord,'');
                // @ts-ignore
                params["keyWords"] = params["keyWords"].replace(KeyWord,'');
                // @ts-ignore
                if(params["keyWords"].length > 0) {
                    // @ts-ignore
                    setSearchParams({...params, keyWords: params['keyWords']});
                }
                else
                {
                    // @ts-ignore
                    delete params["keyWords"]
                    setSearchParams({...params});
                }
                return;
            }
            // @ts-ignore
            setSearchParams({...params,keyWords:params['keyWords']+'|'+String(KeyWord)});
        }

    }

    return (
        <div className={"KeyWord"}>
            <div className={"KeyWord__title"} onClick={()=>{setIsOpenKeyWords(!isOpenKeyWords);openCollapsed();}}>
                Ключевые слова
            </div>
            <div ref={ref} className={`KeyWord__words ${isOpenKeyWords ? 'show' : ''}`}>
                <ul>
                    {props.KeyWords.map((value,index)=>{
                        return(
                            <li className={searchParams.get("keyWords")?.includes(value.KeyWord) ? "link-info" : ''} key={ +"-"+value.Id_KeyWord} onClick={()=>onKeyWordClick(value.KeyWord)}>{value.KeyWord}</li>
                        );
                    })
                    }
                </ul>
            </div>
        </div>
    );
};

export default KeyWord;